import React, { useState, useEffect } from 'react';
import { Text } from '../Text';

const MarketingStandardPreview = ({
  header,
  content,
  footer,
  file,
  imagePreview,
  videoPreview,
  documentPreview,
  buttons = [],
  styles,
}) => {
  const [showAllButtons, setShowAllButtons] = useState(false);

  useEffect(() => {
    setShowAllButtons(false);
  }, [buttons]);

  const displayedButtons = showAllButtons
    ? buttons
    : buttons.length > 3
      ? [...buttons.slice(0, 2), { id: 'see-all', text: 'See all options', type: 'SEE_ALL' }]
      : buttons;

  return (
    <>
      <div className={`w-full flex-grow-1 ${styles['body-container']}`}>
        <div className={`mx-2 mt-2 p-2 ${styles['message-card']}`}>
          {/* MEDIA */}
          {file && (
            <div>
              {imagePreview && (
                <img src={imagePreview} style={{ width: '100%', maxHeight: '180px' }} />
              )}
              {videoPreview && <video controls src={videoPreview} style={{ width: '100%' }} />}
              {documentPreview && <iframe src={documentPreview} style={{ width: '100%' }} />}
            </div>
          )}

          {/* TEXT */}
          {header && <Text type="heading">{header}</Text>}
          {content && <Text type="sub-heading">{content}</Text>}
          {footer && (
            <Text type="sub-heading" color="grey">
              {footer}
            </Text>
          )}
        </div>

        {/* BUTTONS */}
        <div className="flex flex-column gap-2 m-2">
          {displayedButtons.map((btn, i) => (
            <div
              key={i}
              className="p-2 text-center cursor-pointer"
              style={{ background: '#f5f6f7', borderRadius: '10px' }}
              onClick={() => {
                if (btn.type === 'SEE_ALL') setShowAllButtons(true);
              }}
            >
              <Text type="sub-heading" color="#068FFF">
                {btn.text}
              </Text>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default MarketingStandardPreview;
